import { useEffect, useMemo } from 'react';
import styles from './HomePage.module.css';
import { useAllItemsQuery } from '../../../store/api/item.api';
import { useInfiniteSwiperSlides } from '../../../hooks/useInfiniteSwiperSlides';

import supportIcon from '../../../assets/support-icon.svg';

import { Header } from '../../../components/Header/Header';
import { Slider } from '../../../components/Slider/Slider';
import { MainSliderCard } from '../../../components/Slider/mainSliderCard/mainSliderCard';
import { MinSliderCard } from '../../../components/Slider/minSliderCard/minSliderCard';
import { FooterBtn } from '../../../UI/FooterBtn/FooterBtn';


export const HomePage = () => {
	useEffect(() => {
		window.sessionStorage.setItem('schema', 'PS_sharing');
	}, []);

	const { data: allItems = [] } = useAllItemsQuery({
		schema: 'PS_sharing',
	});
	const { data: inMainSliderItems = []} = useAllItemsQuery({
		schema: 'PS_sharing',
		params: { inMainSlider: true}
	})

	const sortedLeaders = useMemo(() => {
		return [...allItems].slice(0, 30);
	}, [allItems]);

	const {
		items: leaderItems,
		loadMore: loadMoreLeaders,
	} = useInfiniteSwiperSlides(sortedLeaders, 5);

	const renderMinSliderItems = (filterFn) =>
		allItems.filter(filterFn).slice(0, 10).map(item => (
			<MinSliderCard
				key={item.id}
				title={item.title}
				price={item.P2_price}
				price_disc={item.P2_price_disc}
				lang={item.lang}
				img={item.img}
				itemId={item.id}
				devices={item.devices}
				style={{maxHeight: 320}}
				buyBtn={true}
			/>
		));

	return (
		<div className='main'>
			<Header />
			
			<div className={styles.slider_block}>
				<Slider sliderType="main">
					{inMainSliderItems?.map(item => (
						<MainSliderCard 
							key={item.id}
							price={item.P2_price} 
							price_disc={item.P2_price_disc} 
							{...item} 
							itemId={item.id} 
						/>
					))}
				</Slider>
			</div>

			<div className={styles.salesLead_block}>
				<h2>Лидеры продаж</h2>
				<Slider sliderType="min" sliderId={'leaders'} onReachEnd={loadMoreLeaders}>
					{leaderItems.map(item => (
						<MinSliderCard
						  key={item.id}
							price={item.P2_price}
							price_disc={item.P2_price_disc}
							devices={item.devices}
							style={{ maxHeight: 320 }}
							{...item}
							itemId={item.id}
							buyBtn 
						/>
					))}
				</Slider>
			</div>

			<div className={styles.slidersBlock}>
				<div className={styles.minSlider}>
					<h2>Подписки</h2>
					<Slider sliderType="min">
						{renderMinSliderItems(item => item.type === 'sub')}
					</Slider>
				</div>

				<div className={styles.minSlider}>
					<h2>PS5</h2>
					<Slider sliderType="min">
						{renderMinSliderItems(item =>
							item.devices?.some(device => device.title.toLowerCase() === 'ps5')
						)}
					</Slider>
				</div>

				<div className={styles.minSlider}>
					<h2>PS4</h2>
					<Slider sliderType="min">
						{renderMinSliderItems(item =>
							item.devices?.some(device => device.title.toLowerCase() === 'ps4')
						)}
					</Slider>
				</div>

				<div className={styles.minSlider}>
					<h2>Полностью на русском</h2>
					<Slider sliderType="min">
						{renderMinSliderItems(item => item.lang === 'Полностью на русском')}
					</Slider>
				</div>
			</div>
			<footer className={styles.footer}>
				<FooterBtn
					title="Support"
					url="https://t.me/eazysupp"
					description="На всякий случай, если у вас будут вопросы"
					img={supportIcon}
				/>
			</footer>
		</div>
	);
};
